export function onlyDigits(e) {
  const keyCode = e.keyCode || e.which;
  const keyValue = String.fromCharCode(keyCode);
  if (!/[0-9]/.test(keyValue) && keyCode !== 13) {
    e.preventDefault();
  }
}

export default onlyDigits;
